import { render, staticRenderFns } from "./EditPublisher.vue?vue&type=template&id=bf8b2e16&scoped=true&"
import script from "./EditPublisher.vue?vue&type=script&lang=js&"
export * from "./EditPublisher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf8b2e16",
  null
  
)

export default component.exports